<template>
  <v-container>
    <v-layout class="mt-2">
      <v-flex>
        <h1 class="mt-0">การจัดการสาขา</h1>
      </v-flex>
      <v-flex class="text-xs-right" style="display: flex; justify-content: flex-end;">
        <div class="form-control">
          <input
            ref="searchInput"
            type="text"
            class="form-control"
            placeholder="ค้นหาชื่อสาขา"
            style="margin-bottom: 10px"
            @keyup.enter="onSearch()"
          />
        </div>
        <v-btn color="primary" outline @click="onSearch()">
          <v-icon class="mr-2">search</v-icon>
          ค้นหา
        </v-btn>
        <v-btn color="primary" @click="showAdd = true">
          <v-icon class="mr-2">add</v-icon>
          {{ $t('Add') }}
        </v-btn>
      </v-flex>
    </v-layout>
    <div class="text-xs-center py-5" v-if="branches.length == 0">
      ไม่มีสาขา
    </div>
    <template v-else>
      <v-card class="mb-2" v-for="(shop, index) in branches" :key="`${shop.name}_${index}`">
        <v-card-text>
          <v-layout>
            <v-flex>
              <div class="title mb-2 primary--text">
                {{ shop.name }}
              </div>
              {{ shop.address }}
              <div class="caption mt-1">
                {{ shop.tel }}
              </div>
              <div class="caption mt-1 grey--text">{{ shop.lat }}, {{ shop.long }}</div>
              <v-chip
                class="white--text"
                :color="shop.type == 'Workshop' ? 'success' : 'warning'"
                small
                disabled
                >{{ shop.type == 'Workshop' ? 'ศูนย์บริการ' : 'ร้านอะไหล่' }}</v-chip
              >
            </v-flex>
            <v-flex shrink>
              <v-btn
                fab
                small
                outline
                class="my-0"
                @click="
                  currentIndex = index
                  currentBranch = shop
                  showEdit = true
                "
              >
                <v-icon>edit</v-icon>
              </v-btn>
            </v-flex>
            <v-flex shrink>
              <v-btn fab small outline class="my-0" @click="deleteBranch(shop)">
                <v-icon>delete</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
      <div class="my-2 text-xs-right">
        <v-pagination
          :length="totalPage"
          v-model="pageNumber"
          @input="getBranchLocation()"
        ></v-pagination>
      </div>
    </template>

    <manage-branch-location v-model="showAdd" @onSave="addBranch"></manage-branch-location>
    <template v-if="currentBranch">
      <manage-branch-location
        v-model="showEdit"
        :currentBranch="currentBranch"
        @onSave="editBranch"
      ></manage-branch-location>
    </template>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import ManageBranchLocation from './ManageBranchLocation.vue'

export default {
  data() {
    return {
      branches: [],
      showAdd: false,
      showEdit: false,
      currentIndex: null,
      currentBranch: null,
      search: undefined,
      totalPage: 2,
      pageNumber: 1,
      pageSize: 10,
    }
  },
  components: {
    ManageBranchLocation
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    })
  },
  async mounted() {
    this.getBranchLocation()
  },
  methods: {
    async getBranchLocation() {
      try {
        this.$store.dispatch('loading')

        const offset = (this.pageNumber - 1) * this.pageSize

        const { result, total } = await this.get(`valvoline/branch-location`, {
          params: {
            name: this.search,
            offset,
            limit: this.pageSize
          }
        })

        if (!this.search) {
          this.$refs.searchInput.value = null
        }
        
        this.branches = result
        this.totalPage = Math.ceil(total / this.pageSize)
      } finally {
        this.$store.dispatch('loading')
      }
    },
    async addBranch(payload) {
      try {
        this.$store.dispatch('loading')

        delete payload['id']

        this.showAdd = false

        await this.post('valvoline/branch-location', {
          batch: [payload]
        })
        await this.getBranchLocation()
      } finally {
        this.$store.dispatch('loading')
      }
    },
    async editBranch(payload) {
      try {
        this.$store.dispatch('loading')

        this.$set(this.branches, this.currentIndex, payload)
        this.showEdit = false
        this.currentIndex = null
        this.currentBranch = null

        const branchId = payload['id']

        await this.patch(`valvoline/branch-location/${branchId}`, payload)
      } finally {
        this.$store.dispatch('loading')
      }
    },
    async deleteBranch(shop) {
      const result = await this.$swal.fire({
        title: this.$t('Do you want to delete {name}?', {
          name: shop.name
        }),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })
      if (result.value) {
        try {
          this.$store.dispatch('loading')

          const shopId = shop['id']

          await this.delete(`valvoline/branch-location/${shopId}`)

          this.pageNumber = 1

          await this.getBranchLocation()
        } finally {
          this.$store.dispatch('loading')
        }
      }
    },
    onSearch() {
      this.search = this.$refs.searchInput.value
      this.pageNumber = 1
      this.getBranchLocation()
    },
  },
  watch: {
    showEdit(value) {
      if (!value) {
        this.currentIndex = null
        this.currentBranch = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/view/analytics/BranchLocation.vue